var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createElement as _createElement } from "react";
import * as React from 'react';
import { css } from 'aphrodite/no-important';
import classNames from 'classnames';
import { ComponentStyles } from 'conversional-theme';
import ImageWrapper from '../imageWrapper';
var selfClosingTags = ['hr', 'img', 'br'];
function NotAnimatedComponent(Tag, props, children) {
    delete props.componentKey;
    return (_createElement(Tag, __assign({}, props, { key: props.key }), children));
}
function SelfClosingComponent(Tag, props) {
    if (Tag === 'img')
        return _createElement(ImageWrapper, __assign({}, props, { key: props.key }));
    return _createElement(Tag, __assign({}, props, { key: props.key }));
}
var BaseComponent = function (props) {
    var children = props.children, _a = props.componentKey, componentKey = _a === void 0 ? (Math.random() * 10000).toString() : _a, _b = props.extraClassName, extraClassName = _b === void 0 ? '' : _b, _c = props.htmlTag, htmlTag = _c === void 0 ? 'div' : _c, _d = props.htmlTagProps, htmlTagProps = _d === void 0 ? {} : _d, _e = props.injectedStyles, injectedStyles = _e === void 0 ? {} : _e, onClick = props.onClick, _f = props.styles, styles = _f === void 0 ? null : _f;
    var isSelfClosing = function (tag) {
        return selfClosingTags.includes(tag);
    };
    var className = classNames(css(styles && styles, ComponentStyles(injectedStyles)), extraClassName);
    var usekey = (componentKey === undefined || componentKey === '' || componentKey === 'undefined') ? (Math.random() * 10000).toString() : componentKey;
    var tagProps = __assign(__assign({ usekey: usekey }, htmlTagProps), { className: className, onClick: onClick });
    if (isSelfClosing(htmlTag)) {
        return SelfClosingComponent(htmlTag, tagProps);
    }
    return NotAnimatedComponent(htmlTag, tagProps, children);
};
export default BaseComponent;
